module.exports = __webpack_public_path__ + "static/media/icon_zip.1ead5aed.svg";